export function euroFormatter(value) {
  const formatter = new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR'
  });

  return formatter.format(value);
}
